<template>
	<div class="mainWrapper direct-purchase">
		<h1>Create Product Transfer</h1>
		<div class="form" v-if="brands.length > 0">
			<div>
				<span class="label">SHOP</span>
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedBrand">
				<span class="label">UPLOAD FILE</span>
				<b-field class="file">
					<input type="file" @change="loadTextFromFile" />
				</b-field>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="transfer-date">
			<span class="label">TRANSFER DATE</span>
			<b-datepicker :date-formatter="dateFormatter" v-model="transferDate" icon="calendar-today"> </b-datepicker>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					QUANTITY
				</div>

				<!-- <div>
					PRICE
				</div> -->

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-model="item.qty" disabled />
				</div>

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" disabled />
				</div>
			</div>
		</div>

		<div v-if="products.length > 0 && error == false" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			bdcodeData: [], // API bdcode data,
			transferDate: null,
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			warehouse: null,
			content: [],
			error: false
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		content: function() {
			this.verifyContent()
		},

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		await this.getShops()

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.warehouse = apiGetWarehouse.data._id

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		verifyContent: async function() {
			for (var transfer of this.content) {
				const bdCode = transfer.bdCode
				const qty = transfer.qty
				const remark = transfer.remark

				const data = {
					brand: this.selectedBrand._id,
					bd_code: bdCode
				}

				const apiProductDetail = await this.$api.searchProduct({ data })

				if (!apiProductDetail || apiProductDetail.data.count == 0) {
					this.$swal.fire('Error!', bdCode + ' is not in ' + this.selectedBrand.name + ' brand!', 'error')
					this.error = true
					return
				}

				let apiProduct = apiProductDetail.data.list[0]

				const duplicate = this.products.filter(product => {
					return product._id == apiProduct._id
				})

				if (duplicate.length > 0) {
					this.$swal.fire('Duplicate!', bdCode + ' is already added!', 'error')
					this.error = true
					return
				}

				apiProduct.qty = qty
				apiProduct.remark = remark

				this.products.push(apiProduct)
			}
		},

		save: async function() {
			// Make sure transfer date is not blank
			if (!this.transferDate) {
				this.$swal.fire('Error!', 'Transfer Date is required!', 'error')

				return
			}

			// Make sure products quantities are not blank
			for (const product of this.products) {
				if (product.qty == null || product.qty == '') {
					this.$swal.fire('Error!', product.bd_code + ' quantity cannot be blank', 'error')

					return
				}
			}

			let data = {
				warehouse: this.warehouse,
				shop_to: this.selectedShop._id,
				brand: this.selectedBrand._id,
				transfer_date: this.$moment(this.transferDate).format('DD/MM/YYYY'),
				product: []
			}

			this.products.map(product => {
				var productData = {}

				productData.id = product._id
				productData.stock = product.qty
				if (product.remark) {
					productData.remark = product.remark
				}

				data.product.push(productData)
			})

			const apiSave = await this.$api.saveProductTransfer({ data })

			if (apiSave) {
				this.$swal.fire(apiSave.data.code)

				this.$router.push('/product-transfer')
			} else {
				this.$swal.fire('Error!', 'Something is wrong!', 'error')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.qty = null
			this.product.remark = null

			const duplicate = this.products.filter(product => {
				return product._id == this.product._id
			})

			if (duplicate.length > 0) {
				this.$swal.fire('Duplicate!', this.product.bd_code + ' is already added!', 'error')

				return
			}

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}

			// if (item == "price") {
			// 	this.products[index].price = Number(value);
			// }
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			this.error = false
			const file = ev.target.files[0]
			const reader = new FileReader()

			let error = false
			let productData = []

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				// Loop every row to put it in array
				raw.map(data => {
					var splitData = data.split(/,/)

					var newData = {}

					newData.bdCode = splitData[0]
					newData.qty = splitData[1]
					newData.remark = splitData[2]

					if ((newData.bdCode && !newData.qty) || newData.qty == '') {
						this.$swal.fire('Error!', newData.bdCode + ' quantity cannot be blank', 'error')
						error = true
						return
					}

					if ((newData.bdCode && !newData.remark) || newData.remark == '') {
						this.$swal.fire('Error!', newData.bdCode + ' remark cannot be blank', 'error')
						error = true
						return
					}

					if (newData.bdCode) {
						productData.push(newData)
					}
				})
			}

			if (error == false) {
				this.content = productData
			}

			reader.readAsText(file)
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/AddProductTransfer.css';
</style>
